export default __webpack_public_path__ + "static/self_yoga-fdb66d38647aaadd023aac9eb3b28109.jpg";